import {useState} from "react";
import ProductPurchaseInfoRequest from "../../rest/request/product/productPurchaseInfoRequest";
import useRequestTracker from "../request/useRequestTracker";
import useAuthRequest from "../request/useAuthRequest";
import {getProductRequest} from "../../../logic/product/productSearchParams";
import solrMultiBuyRequest from "../../rest/request/promotion/solrMultiBuyRequest";
import useSession from "../session/useSession";
import useProductPrices from "../../../pricing/state/useProductPrices";

const formatProducts = (productInfo, prices, loading, multiBuyInfo, purchaseInfo, purchaseLoading) => {
    if(!productInfo) return null;

    if(!prices && loading) return productInfo.products.map(p => ({...p, loadingPurchaseInfo: true }));
    if(!prices) return productInfo.products;

    return productInfo.products.map(p => {
        const info = {...prices[p.id], ...(purchaseInfo?.[p.id] || {})};
        const promoInfo = multiBuyInfo ? multiBuyInfo[p.id] : null;
        if(info)
            return {...p, promotion: promoInfo, ...info}
        else
            return {...p, promotion: promoInfo, loadingPurchaseInfo: loading||purchaseLoading };
    });
}

const useSolrProduct = () => {

    const {
        loading,
        error,
        sendItWithTask
    } = useRequestTracker();
    const {
        sendItWithTask : sendMultiBuy
    } = useRequestTracker();
    const {
        loading : pricingLoading,
        sendIt : sendPricing
    } = useAuthRequest();

    const { sessionData: session, isSignedIn, isCustomer } = useSession();

    const [ productInfo, setProductInfo ] = useState();
    const [ purchaseInfo, setPurchaseInfo ] = useState();
    const [ multiBuyInfo, setMultiBuyInfo ] = useState();

    const pids = productInfo?.products?.map(p => p.id);
    const {
        loading: loadingPrices,
        prices
    } = useProductPrices(pids);

    const onPurchaseInfoReceived = (result) => {
        const purchaseInfoMap = {};
        result.forEach(p => purchaseInfoMap[p.id] = p);
        setPurchaseInfo(purchaseInfoMap);
    }

    const getPricing = (productInfo) => {
        const isLoggedIn = isSignedIn && isCustomer;
        if(isLoggedIn && productInfo.products.length > 0) {
            const req = ProductPurchaseInfoRequest(session.orgID, session.bPartnerID)
                .productIDs(productInfo.products.map(p => p.id));
            sendPricing(req.sendRequest, onPurchaseInfoReceived);
        }
    }

    const getMultiBuyInfo = (productInfo) => {
        const pids = productInfo.products.map(p => p.id);
        const req = solrMultiBuyRequest()
            .productIDs(...pids)

        const onReceived = (resp) => {
            const map = {};
            for(const promo of resp.promotions) {
                if(!promo.isActive(session.priceListID)) continue;
                for(const id of promo.productIDs) {
                    if(!(id in map)) map[id] = [];
                    map[id].push(promo);
                }
            }
            setMultiBuyInfo(map);
        }

        sendMultiBuy(req.sendRequest, onReceived);
    }

    const onProductsReceived = (productInfo) => {
        getPricing(productInfo);
        getMultiBuyInfo(productInfo);
        setProductInfo({
            count: productInfo.count,
            start: productInfo.start,
            products: productInfo.products.map(p => ({
                ...p,
                isBrochure: !(isSignedIn && isCustomer)
            }))
        });
    }

    const getProducts = (searchParams) => {
        const req = getProductRequest(searchParams, session?.priceListID);
        sendItWithTask(req.sendRequest, onProductsReceived);
    }

    const products = formatProducts(productInfo, prices, loadingPrices, multiBuyInfo, purchaseInfo, pricingLoading);

    return {
        loading,
        error,
        products: products,
        productCount: productInfo?.count,
        getProducts
    }
}

export default useSolrProduct;
